import axiosInstance from "../axios/axios-configuration";
import { CancelToken } from "axios"
import { IFascicolo, ILog } from "../shared/interfaces";


const controller = 'Fascicoli';


const getFascicoliUorTree = (aooId: number, uorId: number, cancelToken?: CancelToken): Promise<Partial<IFascicolo>[]> => {
    return axiosInstance.get(`${controller}/${aooId}/${uorId}/GetFascicoliUorTree`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getFascicolo = (aooId: number, uorId: number, id: number, cancelToken?: CancelToken): Promise<IFascicolo> => {
    return axiosInstance.get(`${controller}/${aooId}/${uorId}/GetFascicolo/${id}`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const getStoria = (aooId: number, uorId: number, id: number, cancelToken?: CancelToken): Promise<ILog[]> => {
     return axiosInstance.get(`${controller}/${aooId}/${uorId}/GetStoria/${id}`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const addFascicolo = (aooId: number, uorId: number, fascicoloNode: Partial<IFascicolo>, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.post(`${controller}/${aooId}/${uorId}/Add`, fascicoloNode, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}


const deleteFascicolo = (aooId: number, uorId: number, id: number, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.delete(`${controller}/${aooId}/${uorId}/Delete/${id}`, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}


const updateFascicolo = (aooId: number, uorId: number, id: number, fascicoloNode: any, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.patch(`${controller}/${aooId}/${uorId}/Patch/${id}`, fascicoloNode, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const chiudiFascicolo = (aooId: number, uorId: number, id: number, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.post(`${controller}/${aooId}/${uorId}/ChiudiFascicolo/${id}`, null, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}

const riapriFascicolo = (aooId: number, uorId: number, id: number, cancelToken?: CancelToken): Promise<any> => {
    return axiosInstance.post(`${controller}/${aooId}/${uorId}/RiapriFascicolo/${id}`, null, { cancelToken: cancelToken })
        .then(result => result.data)
        .catch(error => {
            return Promise.reject(error);
        });
}


export default {
    getFascicoliUorTree,
    getFascicolo,
    getStoria,
    addFascicolo,
    deleteFascicolo,
    updateFascicolo,
    chiudiFascicolo,
    riapriFascicolo
}